module.exports = __webpack_public_path__ + "img/ic_notification_list.9c22b59a.svg";